<template>
    <v-layout row wrap>
        <v-flex grow>
            <v-layout row wrap>
                <v-flex xs12 md6>
                    <v-combobox :label="__('labels.event_performance_description')" v-model="date.name"
                              :rules="rules.name" :items="[
                                                'Referent',
                                                'Sendungsbezogene Wissenschaftliche Leitung',
                                                'Programmplanungsbezogene Wissenschaftliche Leitung',
                                                'Gutachter',
                                                'Operateur',
                                                'Untersucher',
                                                'Assistenz',
                                                'Narkosearzt',
                                                'Berater']"></v-combobox>
                </v-flex>
                <v-flex xs12 md6>
                    <s-date-range-picker :label="__('labels.event_performance_date')"
                                         v-model="date.dates" :allowed-dates="allowedDates"></s-date-range-picker>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex shrink v-if="performanceDates.length>1">
            <v-btn fab icon color="primary" small @click="removePerformanceDate(index)">
                <v-icon>delete_outline</v-icon>
            </v-btn>
        </v-flex>
    </v-layout>
</template>

<script>
    import {mapMutations} from 'vuex'
    import {mapState} from 'vuex'

    export default {
        name: "PerformanceDateField",
        props: {
            label: String,
            date: Object,
            index: [Number, String]
        },
        data() {
            return {
                rules: this.$validation.create({
                        name: ['required'],
                    }
                )
            }
        },
        computed: {
            ...mapState('form', [
                'performanceDates',
            ]),
            allowedDates() {
                let flattenedDates = _.flatten(_.map(this.performanceDates, 'dates'))
                if (flattenedDates && flattenedDates[0]) {
                    let firstDate = flattenedDates[0]
                    if (this.$moment(firstDate).isBetween(this.$moment('2020-06-30'), this.$moment('2021-01-01') ) ) {
                        return v => this.$moment(v).isBetween(this.$moment('2020-06-30'), this.$moment('2021-01-01') )
                    } else {
                        return v => !this.$moment(v).isBetween(this.$moment('2020-06-30'), this.$moment('2021-01-01') )
                    }
                }
                return null
            }
        },
        methods: {
            ...mapMutations('form', [
                'removePerformanceDate',
            ]),
        },
    }
</script>

<style scoped>
</style>
